/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type EloshieldClassicStationaryModule,
    EloshieldClassicStationaryModuleFromJSON,
    EloshieldClassicStationaryModuleToJSON,
} from '../models/EloshieldClassicStationaryModule';
import {
    type EloshieldClassicStationaryModuleCreate,
    EloshieldClassicStationaryModuleCreateFromJSON,
    EloshieldClassicStationaryModuleCreateToJSON,
} from '../models/EloshieldClassicStationaryModuleCreate';
import {
    type EloshieldClassicStationaryModuleSortKey,
    EloshieldClassicStationaryModuleSortKeyFromJSON,
    EloshieldClassicStationaryModuleSortKeyToJSON,
} from '../models/EloshieldClassicStationaryModuleSortKey';
import {
    type EloshieldClassicStationaryModuleUpdate,
    EloshieldClassicStationaryModuleUpdateFromJSON,
    EloshieldClassicStationaryModuleUpdateToJSON,
} from '../models/EloshieldClassicStationaryModuleUpdate';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';

export interface EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest {
    eloshieldClassicStationaryModuleCreate: EloshieldClassicStationaryModuleCreate;
}

export interface EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest {
    pageSize: number;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: EloshieldClassicStationaryModuleSortKey;
}

export interface EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest {
    pageSize: number;
}

export interface EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest {
    id: string;
}

export interface EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest {
    id: string;
    eloshieldClassicStationaryModuleUpdate: EloshieldClassicStationaryModuleUpdate;
}

export interface EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest {
    eloshieldClassicStationaryModuleCreate: EloshieldClassicStationaryModuleCreate;
}

export interface EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest {
    id: string;
    eloshieldClassicStationaryModuleUpdate: EloshieldClassicStationaryModuleUpdate;
}

/**
 * EloshieldClassicStationaryModulesApi - interface
 * 
 * @export
 * @interface EloshieldClassicStationaryModulesApiInterface
 */
export interface EloshieldClassicStationaryModulesApiInterface {
    /**
     * Creates request options for eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModule without sending the request
     * @param {EloshieldClassicStationaryModuleCreate} eloshieldClassicStationaryModuleCreate 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts>;

    /**
     * Creates an ELOshield Classic stationary module entity in the backend and allocates ELOshield machine and network IDs for it.
     * @summary Create ELOshield Classic stationary module
     * @param {EloshieldClassicStationaryModuleCreate} eloshieldClassicStationaryModuleCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>>;

    /**
     * Creates an ELOshield Classic stationary module entity in the backend and allocates ELOshield machine and network IDs for it.
     * Create ELOshield Classic stationary module
     */
    eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesListEloshieldClassicStationaryModules without sending the request
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {EloshieldClassicStationaryModuleSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequestOpts(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest): Promise<runtime.RequestOpts>;

    /**
     * List all ELOshield Classic stationary modules known to the system.
     * @summary List ELOshield Classic stationary modules
     * @param {number} pageSize 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {EloshieldClassicStationaryModuleSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRaw(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EloshieldClassicStationaryModule>>>;

    /**
     * List all ELOshield Classic stationary modules known to the system.
     * List ELOshield Classic stationary modules
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModules(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EloshieldClassicStationaryModule>>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMeta without sending the request
     * @param {number} pageSize 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequestOpts(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest): Promise<runtime.RequestOpts>;

    /**
     * Get the page metadata for the listing of ELOshield Classic stationary modules.
     * @summary Get metadata for ELOshield Classic stationary module listing
     * @param {number} pageSize 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRaw(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Get the page metadata for the listing of ELOshield Classic stationary modules.
     * Get metadata for ELOshield Classic stationary module listing
     */
    eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMeta(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModule without sending the request
     * @param {string} id 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch a single ELOshield Classic stationary module entity by ID.
     * @summary Read ELOshield Classic stationary module
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>>;

    /**
     * Fetch a single ELOshield Classic stationary module entity by ID.
     * Read ELOshield Classic stationary module
     */
    eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule without sending the request
     * @param {string} id 
     * @param {EloshieldClassicStationaryModuleUpdate} eloshieldClassicStationaryModuleUpdate 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts>;

    /**
     * Update an ELOshield Classic stationary module entity.
     * @summary Update ELOshield Classic stationary module
     * @param {string} id 
     * @param {EloshieldClassicStationaryModuleUpdate} eloshieldClassicStationaryModuleUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>>;

    /**
     * Update an ELOshield Classic stationary module entity.
     * Update ELOshield Classic stationary module
     */
    eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModule without sending the request
     * @param {EloshieldClassicStationaryModuleCreate} eloshieldClassicStationaryModuleCreate 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts>;

    /**
     * Validates the payload for creating an ELOshield Classic stationary module entity in the backend.
     * @summary Validate create payload
     * @param {EloshieldClassicStationaryModuleCreate} eloshieldClassicStationaryModuleCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validates the payload for creating an ELOshield Classic stationary module entity in the backend.
     * Validate create payload
     */
    eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule without sending the request
     * @param {string} id 
     * @param {EloshieldClassicStationaryModuleUpdate} eloshieldClassicStationaryModuleUpdate 
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts>;

    /**
     * Validates the payload for updating an ELOshield Classic stationary module.
     * @summary Validate update payload
     * @param {string} id 
     * @param {EloshieldClassicStationaryModuleUpdate} eloshieldClassicStationaryModuleUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EloshieldClassicStationaryModulesApiInterface
     */
    eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validates the payload for updating an ELOshield Classic stationary module.
     * Validate update payload
     */
    eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class EloshieldClassicStationaryModulesApi extends runtime.BaseAPI implements EloshieldClassicStationaryModulesApiInterface {

    /**
     * Creates request options for eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModule without sending the request
     */
    async eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eloshieldClassicStationaryModuleCreate'] == null) {
            throw new runtime.RequiredError(
                'eloshieldClassicStationaryModuleCreate',
                'Required parameter "eloshieldClassicStationaryModuleCreate" was null or undefined when calling eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EloshieldClassicStationaryModuleCreateToJSON(requestParameters['eloshieldClassicStationaryModuleCreate']),
        };
    }

    /**
     * Creates an ELOshield Classic stationary module entity in the backend and allocates ELOshield machine and network IDs for it.
     * Create ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EloshieldClassicStationaryModuleFromJSON(jsonValue));
    }

    /**
     * Creates an ELOshield Classic stationary module entity in the backend and allocates ELOshield machine and network IDs for it.
     * Create ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule> {
        const response = await this.eloshieldClassicStationaryModulesCreateEloshieldClassicStationaryModuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesListEloshieldClassicStationaryModules without sending the request
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequestOpts(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling eloshieldClassicStationaryModulesListEloshieldClassicStationaryModules().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * List all ELOshield Classic stationary modules known to the system.
     * List ELOshield Classic stationary modules
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRaw(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EloshieldClassicStationaryModule>>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EloshieldClassicStationaryModuleFromJSON));
    }

    /**
     * List all ELOshield Classic stationary modules known to the system.
     * List ELOshield Classic stationary modules
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModules(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EloshieldClassicStationaryModule>> {
        const response = await this.eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMeta without sending the request
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequestOpts(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMeta().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the page metadata for the listing of ELOshield Classic stationary modules.
     * Get metadata for ELOshield Classic stationary module listing
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRaw(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Get the page metadata for the listing of ELOshield Classic stationary modules.
     * Get metadata for ELOshield Classic stationary module listing
     */
    async eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMeta(requestParameters: EloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.eloshieldClassicStationaryModulesListEloshieldClassicStationaryModulesMetaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModule without sending the request
     */
    async eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch a single ELOshield Classic stationary module entity by ID.
     * Read ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EloshieldClassicStationaryModuleFromJSON(jsonValue));
    }

    /**
     * Fetch a single ELOshield Classic stationary module entity by ID.
     * Read ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule> {
        const response = await this.eloshieldClassicStationaryModulesReadEloshieldClassicStationaryModuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule without sending the request
     */
    async eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule().'
            );
        }

        if (requestParameters['eloshieldClassicStationaryModuleUpdate'] == null) {
            throw new runtime.RequiredError(
                'eloshieldClassicStationaryModuleUpdate',
                'Required parameter "eloshieldClassicStationaryModuleUpdate" was null or undefined when calling eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EloshieldClassicStationaryModuleUpdateToJSON(requestParameters['eloshieldClassicStationaryModuleUpdate']),
        };
    }

    /**
     * Update an ELOshield Classic stationary module entity.
     * Update ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EloshieldClassicStationaryModule>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EloshieldClassicStationaryModuleFromJSON(jsonValue));
    }

    /**
     * Update an ELOshield Classic stationary module entity.
     * Update ELOshield Classic stationary module
     */
    async eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EloshieldClassicStationaryModule> {
        const response = await this.eloshieldClassicStationaryModulesUpdateEloshieldClassicStationaryModuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModule without sending the request
     */
    async eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['eloshieldClassicStationaryModuleCreate'] == null) {
            throw new runtime.RequiredError(
                'eloshieldClassicStationaryModuleCreate',
                'Required parameter "eloshieldClassicStationaryModuleCreate" was null or undefined when calling eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EloshieldClassicStationaryModuleCreateToJSON(requestParameters['eloshieldClassicStationaryModuleCreate']),
        };
    }

    /**
     * Validates the payload for creating an ELOshield Classic stationary module entity in the backend.
     * Validate create payload
     */
    async eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates the payload for creating an ELOshield Classic stationary module entity in the backend.
     * Validate create payload
     */
    async eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.eloshieldClassicStationaryModulesValidateCreateEloshieldClassicStationaryModuleRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule without sending the request
     */
    async eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule().'
            );
        }

        if (requestParameters['eloshieldClassicStationaryModuleUpdate'] == null) {
            throw new runtime.RequiredError(
                'eloshieldClassicStationaryModuleUpdate',
                'Required parameter "eloshieldClassicStationaryModuleUpdate" was null or undefined when calling eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/eloshield_classic_stationary_modules/{id}/validate`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EloshieldClassicStationaryModuleUpdateToJSON(requestParameters['eloshieldClassicStationaryModuleUpdate']),
        };
    }

    /**
     * Validates the payload for updating an ELOshield Classic stationary module.
     * Validate update payload
     */
    async eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRaw(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates the payload for updating an ELOshield Classic stationary module.
     * Validate update payload
     */
    async eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModule(requestParameters: EloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.eloshieldClassicStationaryModulesValidateUpdateEloshieldClassicStationaryModuleRaw(requestParameters, initOverrides);
    }

}
